const app = angular.module('msi.forms', [
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/forms/form-field')
]);

app.service('formsService', require('./forms.service'));
app.directive('ogDisableIfInvalid', require('./disable-if-invalid'));
app.component('ogValidationMessages', require('./validation-messages'));

module.exports = app.name;
